import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const POLL_INTERVAL_MS = 60000;

const Banner = styled.div`
  position: sticky;
  top: 0;
  z-index: 1200;
  width: 100%;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 10px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
`;

const BannerText = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
`;

const ReloadButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.65);
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.24);
  }
`;

async function loadVersion() {
  const response = await fetch(`/version.json?t=${Date.now()}`, {
    cache: 'no-store'
  });

  if (!response.ok) {
    throw new Error(`Version request failed with ${response.status}`);
  }

  const data = await response.json();
  return data?.version ? String(data.version) : null;
}

function AppUpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const currentVersionRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const checkVersion = async () => {
      try {
        const latestVersion = await loadVersion();
        if (!latestVersion || !isMounted) {
          return;
        }

        if (!currentVersionRef.current) {
          currentVersionRef.current = latestVersion;
          return;
        }

        if (latestVersion !== currentVersionRef.current) {
          setUpdateAvailable(true);
        }
      } catch (error) {
      }
    };

    checkVersion();
    const intervalId = setInterval(checkVersion, POLL_INTERVAL_MS);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, []);

  if (!updateAvailable) {
    return null;
  }

  return (
    <Banner>
      <BannerText>Доступна новая версия приложения. Обновите страницу.</BannerText>
      <ReloadButton onClick={() => window.location.reload()}>Обновить</ReloadButton>
    </Banner>
  );
}

export default AppUpdateBanner;
